var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('img',{attrs:{"width":"550","height":"400","alt":"Vue logo","src":require("../assets/logocosmic.png")}}),_c('Layout',{attrs:{"msg":"","title":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }